export default {
    signIn: {
        title: "ברוכים השבים",
        subtitle: "התחברו כדי להמשיך לפיטנגו מרקט",
        emailLabel: "אימייל",
        emailPlaceholder: "you@example.com",
        passwordLabel: "סיסמה",
        passwordPlaceholder: "הסיסמה שלך",
        showPassword: "הצג",
        hidePassword: "הסתר",
        submit: "התחברות",
        submitting: "מתחבר…",
        forgotPassword: "שכחת סיסמה?",
        noAccount: "אין לך חשבון?",
        signUpLink: "צור חשבון",
        validation: {
            emailRequired: "יש להזין אימייל.",
            emailInvalid: "כתובת אימייל אינה תקינה.",
            passwordRequired: "יש להזין סיסמה.",
            passwordLength: "הסיסמה חייבת להכיל לפחות {{min}} תווים."
        },
        errors: {
            wrongCredentials: "אימייל או סיסמה שגויים.",
            emailNotVerified: "יש לאמת את האימייל לפני ההתחברות.",
            passwordResetRequired: "עליך לאפס את הסיסמה לפני ההתחברות.",
            generic: "משהו השתבש. נסה שוב."
        },
        resend: {
            action: "שלח שוב אימייל אימות",
            sent: "אימייל אימות נשלח."
        }
    }
} as const;
